import { Component, Vue, Prop } from 'vue-property-decorator';
import WithRender from './scodepayment.html';
import VuePhoneNumberInput from "vue-phone-number-input";
import config from '@/settings/config';
import { ScodePaymentDto } from '@/Dtos/PaymentDto';
import _axios from '@/services/axios';
import { mapGetters } from 'vuex';
import { PaymentGateWay } from '@/types/CartTypes';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

@WithRender
@Component({
  components: {
    Loading,
    VuePhoneNumberInput
  },
  computed: {
    ...mapGetters("shoppingCart",
      { payment: "getPaymentGateWayDto",
      payCountryCode:"getPayerCountryCode",
      payeeNumber:"getPayerNumber"
    }),
    ...mapGetters("originatorStore", {
      originator: "getOriginator",
      currency: "getWalletCurrency"
    }),
  }
})
export default class ScodePayment extends Vue {
  payCountryCode !:string;
  payeeNumber !:string
  countryCode=''
  phoneNumber=''
  countryCallingCode= "27";
  balance = 0;
  payment!: PaymentGateWay;
  isLoading = false;
  paymentDto = {} as ScodePaymentDto;

  mobileNumber(payload: any) {
   this.countryCallingCode = payload.countryCallingCode;
   this.phoneNumber = payload.nationalNumber;
  }

  mounted() {
    this.getCreditBalance();
    this.countryCode = this.payCountryCode.trim()==""?"ZA":this.payCountryCode;
    this.phoneNumber = this.payeeNumber
  }
  getCreditBalance(): void {
  
  }

  makePayment(): void {
    this.paymentDto.MobileNumber = this.countryCallingCode + this.phoneNumber;
    this.paymentDto.Amount = this.payment.totalAmount;
    this.paymentDto.Description = this.payment.itemDescription;
    this.paymentDto.ItemName = this.payment.itemName;
    this.paymentDto.ReferenceId = this.payment.mPaymentId;
    this.paymentDto.Signature = this.payment.signature;
    this.paymentDto.PaymentProviderServiceFeeTotal = this.payment.paymentProviderServiceFeeTotal;
    this.isLoading = true;

    _axios.post(config.gateway+"credits/scode", this.paymentDto)
      .then(response => {
        window.location.href = "/callback?msg=Scode has been sent to your customer.";
      })
      .catch(err => { console.error(err); })
      .finally(()=>{this.isLoading = false;});
  }

 
}
